/** Bảng màu avatar, đồng bộ tông với màu chủ đạo của hệ thống. */
const AVATAR_COLORS = [
  '#004c4c',
  '#0e7490',
  '#1d4ed8',
  '#6d28d9',
  '#b91c1c',
  '#b45309',
  '#15803d',
  '#be185d',
] as const;

/** Hash ổn định để cùng một tên luôn có cùng một màu. */
const hashName = (name: string): number =>
  Array.from(name).reduce((hash, char) => (hash * 31 + char.charCodeAt(0)) % 100000, 7);

export const avatarColor = (name?: string | null): string =>
  AVATAR_COLORS[hashName((name || '?').toLowerCase()) % AVATAR_COLORS.length];
